import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Box, Heading, Icon } from '@qga/roo-ui/components';

const AlignedHeading = styled(Heading.h3)`
  vertical-align: middle;
  line-height: 1.3;
`;

const ErrorHeading = ({ children }) => {
  return (
    <Box mb={4}>
      <Icon display="inline" mr={1} name="warning" color="ui.error" />
      <AlignedHeading display="inline">{children}</AlignedHeading>
    </Box>
  );
};

ErrorHeading.propTypes = {
  children: PropTypes.node,
};

ErrorHeading.defaultProps = {
  children: null,
};

export default ErrorHeading;
